import { OnboardingSurveyOptionId, SurveyOption } from "@/data/onboarding.data";
import musicProducerOccupationIcon from "@/assets/onboarding/occupation/music-producer.svg";
import songwriterOccupationIcon from "@/assets/onboarding/occupation/songwriter.svg";
import videoCreatorOccupationIcon from "@/assets/onboarding/occupation/video-creator.svg";
import vocalistOccupationIcon from "@/assets/onboarding/occupation/vocalist.svg";
import otherOccupationIcon from "@/assets/onboarding/occupation/other.svg";
import convertStartingServiceIcon from "@/assets/onboarding/starting-service/convert.svg";
import stemSplitterStartingServiceIcon from "@/assets/onboarding/starting-service/stem-splitter.svg";
import masteringStartingServiceIcon from "@/assets/onboarding/starting-service/mastering.svg";
import customVoicesStartingServiceIcon from "@/assets/onboarding/starting-service/custom-voices.svg";
import otherStartingServiceIcon from "@/assets/onboarding/starting-service/other.svg";

export const getSurveyOptionIconKey = (id: OnboardingSurveyOptionId) => {
  switch (id) {
    case "occupation/music-producer":
      return musicProducerOccupationIcon;
    case "occupation/songwriter":
      return songwriterOccupationIcon;
    case "occupation/vocalist":
      return vocalistOccupationIcon;
    case "occupation/video-creator":
      return videoCreatorOccupationIcon;
    case "occupation/other":
      return otherOccupationIcon;
    case "starting-service/convert":
      return convertStartingServiceIcon;
    case "starting-service/stem-splitter":
      return stemSplitterStartingServiceIcon;
    case "starting-service/mastering":
      return masteringStartingServiceIcon;
    case "starting-service/custom-voices":
      return customVoicesStartingServiceIcon;
    case "starting-service/other":
      return otherStartingServiceIcon;
  }
};

export const buildSurveySelectionOption = (
  id: OnboardingSurveyOptionId,
  title: string,
): SurveyOption => {
  return {
    id,
    title,
    icon: getSurveyOptionIconKey(id),
    answerType: "SELECTION",
  };
};

export const buildSurveyOtherOption = (
  id: OnboardingSurveyOptionId,
): SurveyOption => {
  return {
    id,
    title: "Other",
    icon: getSurveyOptionIconKey(id),
    answerType: "INPUT",
  };
};
